import Layers from "slotworks/graphics/layers/layers";
import { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import SmartUIManager from "slotworks/smart-ui/smart-ui-manager";
import DeviceInfo from "slotworks/utils/device-info";
import gameiomModel from "gameiom/model/gameiom-model";
import {UiDenomDisplayType} from "gameiom/wrapper/wrapper-data";
import {Services} from "slotworks/services/services";

export function SetupAGSSettingsMenus() {
    const settingsGroups = [];
    const TITLE_ID = "[bet.den]";
    const TITLE_ALIAS = "bet.mul";

    if (Layers.MenusContent.hasScene("betsetting")) {
        const betSettingsGroup = SmartUIManager.newSmartUIGroup(Layers.MenusContent, "betsetting");
        SmartUIManager.registerButtonToGroup("bet_menu", Layers.BetBar, ["default", "freespins", "default_currency", "freespins_currency"], betSettingsGroup);
        settingsGroups.push(betSettingsGroup);

        if (gameiomModel.denomDisplay && gameiomModel.denomDisplay === UiDenomDisplayType.multiplier) {
            const scenes = Layers.MenusContent.getScenes();
            const texts = scenes.get("betsetting").config.text;
            for (let i = 0; i < texts.length; i++) {
                const text = texts[i];
                if ( text.id === TITLE_ID) {
                    text.content = `[${TITLE_ALIAS}]`;
                    break;
                }
            }
            if (Layers.MenusContent.getText(TITLE_ID)){
                Layers.MenusContent.getText(TITLE_ID).text = Services.translations.get(TITLE_ALIAS);
            }
        }
    }

    const generalSettingsGroup = SmartUIManager.newSmartUIGroup(Layers.MenusContent, "general");
    SmartUIManager.registerButtonToGroup("menu", Layers.BetBar, ["default", "freespins", "default_currency", "freespins_currency"], generalSettingsGroup);
    settingsGroups.push(generalSettingsGroup);

    const paytableGroup = SmartUIManager.newSmartUIGroup(Layers.MenusContent, "paytable");
    SmartUIManager.registerButtonToGroup("information", Layers.BetBar, ["default", "freespins", "default_currency", "freespins_currency"], paytableGroup);
    SmartUIManager.registerButtonToGroup("help", Layers.MenusContent, ["general"], paytableGroup);
    settingsGroups.push(paytableGroup);

    const autoplayGroup = SmartUIManager.newSmartUIGroup(Layers.MenusContent, "autoplay_ukgc");
    SmartUIManager.registerButtonToGroup("auto_start", Layers.SmartButton, ["default", "skip", "freespins"], autoplayGroup);
    settingsGroups.push(autoplayGroup);

    for (const settingsGroup of settingsGroups) {
        settingsGroup.setFlagsOnShow([SmartUIFlag.MENU]);
        settingsGroup.addDisableCondition([SmartUIFlag.FREE_SPINS]);
        settingsGroup.addDisableCondition([SmartUIFlag.PROMPT]);
        settingsGroup.addDisableCondition([SmartUIFlag.EXTERNAL_DISABLE]);
        SmartUIManager.addAutoHideGroupCondition(settingsGroup, [], [SmartUIFlag.IDLE]);
    }

    if (DeviceInfo.isDesktop) {
        // sound toggle
        SmartUIManager.newSmartUIGroup(Layers.Header, "default");
        SmartUIManager.newSmartUIGroup(Layers.Header, "bonus");
    }

    // Disable spin and skip when awaiting response from the wrapper
    const spinGroup = SmartUIManager.get("spin");
    if (spinGroup) {
        spinGroup.addDisableCondition([SmartUIFlag.AWAITING_RESPONSE]);
    }
    const skipGroup = SmartUIManager.get("skip");
    if (skipGroup) {
        skipGroup.addDisableCondition([SmartUIFlag.AWAITING_RESPONSE]);
    }

    // AGS games should show skip button when no flags are active, not spin button
    SmartUIManager.addAutoShowGroupCondition(skipGroup, []);
}
